export default __webpack_public_path__ + "static/media/factory.7d2339b7.png";